export const CONSTs = {
  TYPE_ANALYTICS_CUSTOM_EVENT: 'triggerAnalytics'
}
